// src/business/components/Panel.jsx
export default function Panel({ eyebrow = "", title, subtitle = "", right, icon: Icon = null, className = "", contentClassName = "", hideHeader = false, children }) {
  return (
    <section
      className={`
        operations-surface overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-[0_1px_2px_rgba(15,23,42,0.035)]
        dark:border-neutral-800 dark:bg-neutral-900 dark:shadow-none
        ${className}
      `}
    >
      {!hideHeader ? (
        <div
          className="
            operations-panel-header
            flex flex-col gap-2.5 px-4 py-3 sm:px-4
            sm:flex-row sm:items-center sm:justify-between
            border-b border-neutral-200/80
            dark:border-neutral-700/80
          "
        >
          <div className="min-w-0 flex-1">
            {eyebrow ? (
              <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-neutral-500 dark:text-neutral-400">
                {eyebrow}
              </div>
            ) : null}
            <div className={`flex items-center gap-2 ${eyebrow ? "mt-2" : ""}`}>
              {Icon ? (
                <span className="inline-flex h-8 w-8 items-center justify-center rounded-xl bg-neutral-100 text-neutral-600 dark:bg-neutral-800 dark:text-neutral-300">
                  <Icon className="h-4 w-4" />
                </span>
              ) : null}
              <h3
                className="
                  min-w-0 flex-1
                  text-base font-semibold leading-6 tracking-[-0.01em]
                  text-neutral-800
                  dark:text-neutral-50
                "
              >
                {title}
              </h3>
            </div>
            {subtitle ? (
              <p className="mt-1 text-xs text-neutral-500 dark:text-neutral-400">
                {subtitle}
              </p>
            ) : null}
          </div>

          {right ? (
            <div
              className="
                operations-panel-actions
                w-full
                sm:w-auto sm:shrink-0
                text-xs
                text-neutral-600
                dark:text-neutral-400
              "
            >
              {right}
            </div>
          ) : null}
        </div>
      ) : null}

      <div
        className={`
          p-3.5 sm:p-4
          text-neutral-700
          dark:text-neutral-200
          ${contentClassName}
        `}
      >
        {children}
      </div>
    </section>
  );
}
